<template>
  <div
    class="sidebar-list group-tabs favourite-region"
    :class="{ 'drag-active': dragActive }"
    draggable="true"
    @dragenter="dragEnter"
    @dragover="dragOver"
    @dragleave="dragLeave"
    @dragover.prevent
    @drop.stop="dragDrop($event)"
  >
    <h6 class="section-label px-2 mb-1">{{ $t('favourites_title') }}</h6>
    <div v-for="favourite in favouritesLimited" :key="favourite.id" class="list-group">
      <a class="list-group-item list-group-item-action" @click="onClick(favourite)">
        <DocumentIcon v-if="favourite.extension" :extension="favourite.extension" :show-small-only="true" />
        <BImg
          v-else-if="favourite.parentId !== undefined"
          fluid
          :src="require('@/assets/images/pages/folder.svg')"
          :alt="$t('folder_alt')"
          class="folder-icon"
        />
        <span v-else class="iconfont icon-vault icon-24 icon" />
        <span class="align-middle favourite-label">{{ favourite.name }}{{ favourite.extension }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { VBModal, BImg } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import DocumentIcon from '@/components/DocumentIcon'

export default {
  name: 'Favourites',
  directives: {
    Ripple,
    'b-modal': VBModal
  },
  components: {
    BImg,
    DocumentIcon
  },
  data: function() {
    return {
      dragActive: false
    }
  },
  computed: {
    ...mapState('favourite', ['favouritesSideBar']),
    ...mapState('home', ['selectedEntities']),
    favouritesLimited: function() {
      return this.favouritesSideBar.slice(0, 5)
    }
  },
  mounted: function() {
    this.$store.dispatch('favourite/getFavouritesSideBar', {
      self: this,
      visible: false,
      itemsPerPage: 5
    })
  },
  methods: {
    onClick: function(favourite) {
      const parentId = favourite.parentId ? favourite.parentId : '0'
      if (favourite.extension) {
        // document
        this.$router.push(`/vaults/${favourite.vaultId}/${parentId}?documentId=${favourite.id || favourite._id}`)
      } else if (favourite.parentId !== undefined) {
        // folder
        this.$router.push(`/vaults/${favourite.vaultId}/${parentId}`)
      } else {
        // vault
        this.$router.push(`/vaults/${favourite.id || favourite._id}/0`)
      }
    },
    dragEnter(e) {
      this.dragActive = true
    },
    dragOver(e) {
      e.preventDefault()
      this.dragActive = true
    },
    dragLeave(e) {
      this.dragActive = false
    },
    dragDrop(e) {
      e.preventDefault()
      this.dragActive = false

      const entityType = e.dataTransfer.types.includes('folder') ? 'folder' : 'doc'
      const entity = JSON.parse(e.dataTransfer.getData(entityType))

      this.$store.dispatch('favourite/addFavourite', {
        self: this,
        entity
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  margin-right: 10px;
}

.sidebar-list {
  overflow: auto;
}

.group-tabs {
  height: auto !important;
}

.section-label {
  margin-top: 1rem;
}

.favourite-region {
  min-height: 8rem;
  margin-top: 1rem;
}

.drag-active {
  border-radius: 8px;
  border: 2px dashed var(--primary);
}

.folder-icon {
  height: 2rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.favourite-label {
  display: inline-block;
  width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
